<template>
  <div>
    <InnerHeader
      :cover="require('../../assets/img/careers/cover.jpg')"
      :bgColor="'#6E5925'"
      :bgPosition="'0 25%'"
      :links="links"
    />
    <Careers v-if="!$route.query.page"/>
    <Internships v-else-if="$route.query.page === 'internships'"/>
    <Events v-else-if="$route.query.page === 'events'"/>
    <ApplicationForm v-else-if="$route.query.page === 'application'"/>
    <Jobs v-else-if="$route.query.page === 'jobs'"/>
    <JobsPreview v-else-if="$route.query.page === 'jobsPreview'"/>
    <!-- <div v-else class="under-construction">
      <h2>Страницата е в процес на разработка</h2>
    </div> -->
  </div>
</template>

<script>
import InnerHeader from '../shared/InnerHeader';
import Careers from './Careers';
import Events from './Events';
import Internships from './Internships';
import ApplicationForm from './ApplicationForm';
import Jobs from './Jobs';
import JobsPreview from './JobsPreview';
export default {
  components: {
    InnerHeader,
    Careers,
    Events,
    Internships,
    ApplicationForm,
    Jobs,
    JobsPreview
  },
  computed: {
    links() {
      return [
        {
          name: this.$t('nav5-1'),
          url: '/careers'
        },
        {
          name: this.$t('nav5-2'),
          url: '/careers?page=internships'
        },
        {
          name: this.$t('nav5-3'),
          url: '/careers?page=events'
        },
        {
          name: this.$t('nav5-4'),
          url: '/careers?page=jobs'
        },
        {
          name: this.$t("nav5-5"),
          url: "/careers?page=application"
        }
      ];
    }
  },
  mounted() {
    document.title = this.$t('title5');
  },
  destroyed() {
    document.title = this.$t('title0');
  }
};
</script>

<style>
</style>
